module.exports = __webpack_public_path__ + "img/logo1.b8228019.png";